import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import preloadimg from "../../assets/img/preloader1.gif";
import { useCustomVisuals } from "../../hooks/useCustomVisuals";

const Preview = (props) => {
  const { fetchReportData } = useCustomVisuals();

  const [pbireportsConfig, setpbireportsConfig] = useState();

  const id = props.report_id;

  const pbireports = pbireportsConfig?.data;

  const [isloading, setIsLoading] = useState(true);
  const [Repotisloading, setRepotisloading] = useState(true);
  const [errorData, seterrorData] = useState(false);



  useEffect(() => {
    if (isloading) {
      const fetchViusals = async () => {
        try {
          const json = await fetchReportData(id);
          setpbireportsConfig(json);
          setIsLoading(false);
          seterrorData(false);
        } catch (err) {
          setpbireportsConfig();
          setIsLoading(false);
          seterrorData(true);
        }
      };
      fetchViusals();
    }
  }, [id, isloading]); // eslint-disable-line react-hooks/exhaustive-deps


  const embeddingData = pbireports?.embedReport;
  const EmbedUrl = embeddingData?.url;
  const Embedaccess_token = embeddingData?.embedToken;
  const EmbedPBIreport_id = `${embeddingData?.reportGuid}`;
  const embdData = (TrigerdData) => {
    // console.log("Trigerd data")
    // console.log(TrigerdData);
  };

  return (
    <div style={{ position: "relative", height: "100%" }}>
      {Repotisloading && (
        <div
          style={{
            position: "absolute",
            background: "white",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 0,
            paddingTop: "4rem",
          }}
          className="pageLoading"
        >
          <img width={200} src={preloadimg} alt="Loading" />
        </div>
      )}

      {!isloading && !errorData && (
        <div style={{ height: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "10px",
              alignItems: "center",
            }}
          >
            <span
              style={{ fontSize: "16px", color: "#253978", fontWeight: "600" }}
            >
              {props.title}
            </span>

            <div
              style={{
                display: "flex",
                paddingBottom: "10px",
                alignItems: "center",
                gridGap: "20px",
                alignContent: "center",
              }}
            >



            </div>
          </div>

          <PowerBIEmbed
            embedConfig={{
              type: "visual", // Supported types: report, dashboard, tile, visual, and qna.
              id: EmbedPBIreport_id,
              embedUrl: EmbedUrl,
              accessToken: Embedaccess_token,
              tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
              pageName: `${props.report_name}`,
              visualName: `${props.visuals_id}`,
              settings: {
                navContentPaneEnabled: false,
                panes: {
                  filters: {
                    expanded: true,
                    visible: false,
                  },
                },
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function (event) {
                    // console.log("Report loaded");
                    setRepotisloading(false);
                  },
                ],
                [
                  "rendered",
                  function (event) {
                    // console.log("Report rendered");
                  },
                ],

                [
                  "saved",
                  function (event) {
                    // console.log("Report Saved");
                  },
                ],
                [
                  "error",
                  function (event) {
                    // console.log("error");
                  },
                ],
              ])
            }
            cssClassName={"report-style-class"}
            getEmbeddedComponent={embdData}
          />
        </div>
      )}

      {!isloading && errorData && (
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          There Is Some Issue On this Report, Please Contact With Admin Or Try
          Again Later
        </div>
      )}


    </div>
  );
};

export default Preview;
